import { Activity, AlertTriangle, CheckCircle2, Radio } from 'lucide-react';

const statusCopy = {
  healthy: { label: 'Healthy', color: '#2C5545', icon: CheckCircle2 },
  watch: { label: 'Watch closely', color: '#E07A5F', icon: Activity },
  critical: { label: 'Needs attention', color: '#C85A3C', icon: AlertTriangle },
  no_data: { label: 'Awaiting data', color: '#8A8A8A', icon: Radio },
};

export const VoiceHealthSummary = ({ data }) => {
  const status = statusCopy[data.health_status] || statusCopy.no_data;
  const StatusIcon = status.icon;
  const metrics = [
    { label: 'Observed sessions', value: data.total_sessions },
    { label: 'Failed sessions', value: data.failed_sessions },
    { label: 'Completed playback', value: data.completed_sessions },
  ];

  return (
    <section className="grid gap-5 md:grid-cols-[1.2fr_2fr]" data-testid="voice-health-summary">
      <div className="border border-[#EAE5D9] bg-white p-6 sm:p-8 rounded-md">
        <p className="text-xs font-semibold uppercase text-[#8A8A8A]">System health score</p>
        <div className="mt-5 flex items-end gap-3">
          <span className="font-serif text-5xl text-[#1E3F33]" data-testid="voice-health-score">
            {data.health_score ?? '—'}
          </span>
          {data.health_score !== null && <span className="mb-1 text-sm text-[#8A8A8A]">/ 100</span>}
        </div>
        <div className="mt-5 flex items-center gap-2" style={{ color: status.color }} data-testid="voice-health-status">
          <StatusIcon className="h-4 w-4" />
          <span className="text-sm font-semibold">{status.label}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 border-y border-[#EAE5D9] sm:grid-cols-3">
        {metrics.map((metric) => (
          <div className="border-b border-[#EAE5D9] px-1 py-6 sm:border-b-0 sm:border-r sm:px-6 last:border-r-0" key={metric.label}>
            <p className="font-serif text-4xl text-[#1A1A1A]" data-testid={`voice-health-${metric.label.toLowerCase().replaceAll(' ', '-')}`}>
              {metric.value}
            </p>
            <p className="mt-2 text-xs font-semibold uppercase text-[#8A8A8A]">{metric.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
